/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignsUpdatePathParams,
	CampaignsUpdateRequest,
	CampaignsUpdateResponse,
} from '../types/CampaignsUpdate'

/**
 * PUT /campaigns/:campaign
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::update
 */
export async function campaignsUpdate(
	campaign: CampaignsUpdatePathParams['campaign'],
	data: CampaignsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignsUpdateResponse>> {
	return axiosInstance.put(`/campaigns/${campaign}`, data, config)
}
